<template>
  <div class="inner-container">
    <div class="indicator-wrapper">
      <scroll-indicator color='white'></scroll-indicator>
    </div>
    <div class="loader-container" v-if="loader">
      <v-layout fill-height align-center justify-center ma-0>
        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
      </v-layout>
    </div>
    <div class="inner-display">
      <div tile v-for="(item,index) in $store.state.jewelry" :key="index" style="margin:1rem" class="jewelry-card">
                  <v-card-title primary-title>
                    <div>
                      
                      <h3 style="font-family: 'DINPro Regular'" center>{{ item.title}}</h3>
                    </div>
                  </v-card-title>
                  <v-img
                    :src="item.imageUrl"
                    :lazy-src="item.imageUrl"
                    aspect-ratio="1"
                    class="jewelry-image"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
      </div>      
        
    </div>
  </div>
</template>

<script>
import { CMS } from "../../api";
import ScrollIndicator from '../ScrollIndicator';

export default {
  components: {ScrollIndicator},
  created() {
      this.loader = true
      if (this.$store.state.currentFilter.toLowerCase() == 'all') this.currentFilter = 'all'
      this.catagory = this.$store.state.collection
      this.getJewelry()
  },
  data() {
    return {
       currentFilter: "catagory",
       currentSort: 'title',
       loader: true
    };
  },
  methods: {
    getJewelry() {
      CMS.getJewelry(this, this.currentFilter, this.currentSort, this.catagory, response => {
        this.loader = false
      });
    }
  }
};
</script>

<style scoped>
.nav-tile {
    -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.indicator-wrapper {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 0.3rem;
  z-index: 99999999999;
}
.loader-container {
  position: fixed;
  top: 0;
  height: 100vh;
  z-index: 99999;
  width: 100vw;
  background-color: rgba(0,0,0,0.6);
}
.inner-container {
    min-height: 100vh;
    padding-top: 5rem;
    background: #e2e1e0;
}
.inner-display {
  display: flex;
  flex-flow: row wrap;
  padding: 1rem;
  align-items: center;
  justify-content: center;
}
.jewelry-image {
  height: auto;
  width: auto;
}
.jewelry-card {
  width: 15rem;
  height: auto;
  margin-left: 1rem;
  margin-right: 1rem;
  background: white;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}
#drawerButton {
    position: fixed;
}
.nav-tile:hover {
    cursor: pointer;
    box-shadow:rgba(0, 0, 0, 0.3) 0 16px 16px 0;
  -webkit-box-shadow:rgba(0, 0, 0, 0.3) 0 16px 16px 0;
  -moz-box-shadow:rgba(0, 0, 0, 0.3) 0 16px 16px 0;
}
</style>



// WEBPACK FOOTER //
// ViewCollection.vue?5f7e9695